export const border = {
  primaryRadius: '4px',
  secondaryRadius: '8px',
  tertiaryRadius: '20px',
} as const;
